import { Box, Paper, TextField, Typography, Link, Button } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ToastMessage from "../components/toast-message";

function Auth() {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        username: '',
        password: '',
    });

    const [status, setStatus] = useState({
        type: 0,
        message: ''
    });

    const clearToastMessge = () => {
        setStatus({
            type: 0,
            message: ''
        });
    };

    const handleInputChange = (e) => {
        const {name, value} = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const saveToLocalStorage = () => {
        localStorage.setItem('admin', JSON.stringify({username: formData.username}));
        navigate('/');
    };

    const login = async () => {
        if (!formData.username || !formData.password) {
            setStatus({
                type: 0,
                message: 'please fill in all fields'
            });
            
            return;
        }

    
        try {
            const response = await axios.post('https://api.wajls.com/admin/v1/verify_login.php', formData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

    
            const result = response.data;
            
            if (result.success) {
                saveToLocalStorage();
            }
            else {
                setStatus({
                    type: 0,
                    message: result.message
                });
            }
        } catch (error) {
            console.error()
        }
    };

   
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                backgroundColor: "green",
            }}
        >
                        <Paper
                elevation={3}
                sx={{
                    padding: 2,
                    width: 350,
                    borderRadius: 2,
                    margin: 2,
                    backgroundColor: '#f2f7fa'
                }}
            >

                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 600,
                        borderBottom: "1px solid #e0e0e0",
                        mb: 2,
                    }}
                >
                    Sign In
                </Typography>

                <TextField
                    fullWidth
                    label="username"
                    margin="normal"
                    name="username"
                    value={formData.username}
                    onChange={handleInputChange}
                    sx={{ backgroundColor: '#fff' }}
                />

                <TextField
                    fullWidth
                    label="password"
                    margin="normal"
                    name="password"
                    type="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    sx={{ backgroundColor: '#fff' }}
                />
                
              
                <Button
                    variant="contained"
                    fullWidth
                    sx={{

                    }}
                    onClick={login}
                >
                    Sign In
                </Button>
            </Paper>  

            {status.message && <ToastMessage type={status.type} message={status.message} onClose={clearToastMessge}/>}
        </Box>
    );
}
export default Auth;